export const ABONAR_BLOCKED_MESSAGE =
  'La función "Abonar" está bloqueada para tu cuenta.';

export const CREAR_OBLIGACION_BLOCKED_MESSAGE =
  'La función "Crear Obligación" está bloqueada para tu cuenta.';

export const dispatchFeatureBlockedAlert = (dispatch, importAlertState, message) => {
  dispatch(
    importAlertState({
      content: message,
      state: 'warning',
      duration: 4,
    }),
  );
};
